import React, { Component } from 'react';
import { getString, LocaleString } from '@nackle/intl-tools';
import LanguagePicker from '../language-picker';
import Siren from '../../../assets/images/siren.png';
import './error-display.less';


export default class ErrorDisplay extends Component {
	constructor( props ) {
		super( props );
		const { error } = props;

		switch ( error ) {
			case 'path':
				this.state = {
					hasError: true,
					errorText: <LocaleString code="errors.content.path" TextComponent="h5" />
				};
				break;
			default:
				this.state = {
					hasError: false,
					errorText: ''
				};
				break;
		}
	}

	componentDidCatch( error, info ) {
		this.setState(
			{
				hasError: true,
				errorText: getString( 'errors.content.generic' )
			}
		);
	}

	render() {
		const { hasError, errorText } = this.state;
		if ( hasError ) {
			return (
				<div className="error-page">
					<div className="error-container">
						<img alt='error' src={ Siren } />
						<LanguagePicker />
						<LocaleString code="errors.content.uhoh" TextComponent="h1"/>
						<LocaleString code="errors.content.connect" TextComponent="h3"/>
						{ errorText }
					</div>
				</div>
			);
		}
		return this.props.children;
	}
}